<template>
  <div id="new-page">
    <div>
      <table style="margin: 0 auto;margin-top: 20px">
        <tr>
          <td>
            <label>Slug</label>
          </td>
          <td>
            <input type="text" v-model="slug" :disabled="!isNew" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Locale</label>
          </td>
          <td>
            <select multiple v-model="countries">
              <option value="LT">Lithuania</option>
              <option value="PL">Poland</option>
            </select>
            <div style="display:inline-block">
              <div>Language</div>
              <select v-model="language">
                <option value="lt">Lithuanian</option>
                <option value="pl">Polish</option>
                <option value="en">English</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <label>Title</label>
          </td>
          <td>
            <input type="text" v-model="title" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Description</label>
          </td>
          <td>
            <input type="text" v-model="short" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Image</label>
          </td>
          <td>
            <input type="text" v-model="image" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Text</label>
          </td>
          <td>
            <div>Preview: <input type="checkbox" id="checkbox" v-model="preview" style="width: 50px" /></div>
            <textarea v-model="text" v-if="!preview" />
            <MarkdownIt v-if="preview" class="mdown md-body" :content="text" style="width: 400px;text-align:left" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Date</label>
          </td>
          <td>
            <DatePicker v-model="date" mode="datetime" />
          </td>
        </tr>
      </table>

      <button
        v-on:click="saveArticle()"
        style="background-color: #333;color: white; padding:10px;cursor:pointer;margin-top:20px;margin-bottom: 30px"
      >Save news update</button>
    </div>
  </div>
</template>

<style scoped lang="less">
#new-page {
  input {
    padding: 10px;
    width: 700px;
  }
  textarea {
    width: 700px;
    height: 500px;
  }
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
  .mdown {
    background-color: white;
    padding: 10px;
  }
}
</style>

<script>
import api from "../services/api";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import MarkdownIt from "markdown-it-vue";
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home",
  components: { DatePicker, MarkdownIt },
  data: function () {
    return {
      slug: '',
      countries: [],
      language: 'lt',
      title: '',
      text: '',
      image: '',
      short: '',
      preview: false,
      date: new Date(),
      isNew: true
    };
  },
  created: async function() {
    // const state = this.$store.state;
    const id = this.$route.params.id;
    this.isNew = id == "new";
    console.log(id);
    if (id) {
      const news = await api.getArticles();
      for (let i = 0; i < news.length; i++) {
        if (news[i].id === id) {
          const entry = news[i];
          this.slug = entry.id;
          this.countries = entry.countries;
          this.language = entry.language;
          this.title = entry.title;
          this.text = entry.text;
          this.short = entry.short;
          this.image = entry.image;
          if (entry.date) {
            this.date = new Date(entry.date._seconds * 1000);
          }
          break;
        }
      }
    }
  },
  methods: {
    saveArticle: async function () {
      const getEntryData = () => {
        return {
          countries: this.countries,
          language: this.language,
          title: this.title,
          text: this.text,
          short: this.short,
          image: this.image,
          date: this.date.getTime()
        };
      };
      const data = getEntryData();
      if (this.$route.params.id == "new") {
        await api.createBlogArticle(this.slug, data);
      } else {
        await api.createBlogArticle(this.slug, data);
      }
      this.$router.push({ name: "news" }).catch(() => {});
    },
  },
};
</script>
